import { useCallback, useEffect, useMemo, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { loadFooterConfig } from 'arbitrip-common/theme/footer/helpers';
import { getIsracardBaseUrl } from 'arbitrip-common/client/utils/IsracardUrls';
import { isIsracardCompany } from '@/utils/isCompany';
import Logo from './Logo';
import { getCookiesLng } from '../../../../utils/cookies';

const FooterBar = ({ profile, t }) => {
	const isIsracard = useMemo(() => isIsracardCompany(), []);
	const hostnameParam = useMemo(() => (isIsracard ? { isracardBaseUrl: getIsracardBaseUrl() } : null), [isIsracard]);
	const [config, setConfig] = useState({});

	useEffect(() => {
		async function fetchConfig() {
			if (profile?.company?.id && _.isEmpty(config)) {
				const loadedConfig = await loadFooterConfig(profile.company.id);
				setConfig(loadedConfig);
			}
		}
		fetchConfig();
	}, [profile]);

	const { Information, ...otherSections } = config;

	
	const cookieSettingsHandler = useCallback(()=>{
		if (window.OneTrust) {
			window.OneTrust.changeLanguage(getCookiesLng(document.dir));
			window.OneTrust.ToggleInfoDisplay();
		}
	},[document.dir]);
	

	return (
		<footer data-testid="footer">
			<div className="inner-container">
				{/* Render the Information section */}
				{Information && (
					<div className="section">
						{Information.Logo && <Logo src={t(Information.Logo)} alt="Footer Logo" />}
						{Information.Slogan && <span className="info-text slogan">{t(Information.Slogan)}</span>}
						{Information.CopyRight && (
							<span className="copyright">
								{t(Information.CopyRight, { year: new Date().getFullYear() })}
							</span>
						)}
					</div>
				)}

				{/* Render other sections */}
				{Object.entries(otherSections).map(([key, values]) => {
					const hasValidLinks = Object.values(values).some((value) => value && value.trim() !== '');
					return (
						hasValidLinks && (
							<div key={key} className="section">
								<span className="section-title">{t(key)}</span>
								{Object.entries(values).map(([label, urlKey]) => {
									const url = hostnameParam ? t(urlKey, hostnameParam) : t(urlKey);
									if (!url || url.trim() === '') return null;
									
									if (label === 'Cookies'){
										return <a key={label}  href="#" rel="noopener noreferrer" className="footer-link" onClick={cookieSettingsHandler}>
											{t(label)}
										</a>
									}	
									const isInternal = url.startsWith('/');

									return isInternal ? (
										<Link key={label} to={url} className="footer-link">
											{t(label)}
										</Link>
									) : (
										<a
											key={label}
											href={url}
											target="_blank"
											rel="noopener noreferrer"
											className="footer-link"
										>
											{t(label)}
										</a>
									);
								})}
							</div>
						)
					);
				})}
			</div>
		</footer>
	);
};

export default withTranslation()(FooterBar);
